// General system settings
export const SETTINGS = {
  // Currency settings
  CURRENCY: {
    symbol: '£',
    code: 'GBP',
    locale: 'en-GB'
  },
  
  // Date formats
  DATE_FORMATS: {
    display: 'DD/MM/YYYY',
    api: 'YYYY-MM-DD',
    report: 'MMMM YYYY'
  },
  
  // API settings
  // API: {
  //   baseUrl: 'https://v2.sojoclient.com/backend/main.php',
  //   timeout: 30000
  // },

  API: {
    baseUrl: 'https://v2.sojoclient.com/backend/main.php',
    timeout: 30000
  },
  
  // Report settings
  REPORTS: {
    itemsPerPage: 30,
    defaultCurrency: 'GBP',
    companyName: 'Sojourn Executive',
    companyLogo: '/sojourn.png'
  },
  
  // PDF settings
  PDF: {
    format: 'A4',
    orientation: 'portrait',
    margin: {
      top: '20mm',
      right: '15mm',
      bottom: '20mm',
      left: '15mm'
    }
  },
  
  // Excel settings
  EXCEL: {
    sheetName: 'Property Report',
    headers: [
      'Booking Name',
      'Source', 
      'No. Nights',
      'Amount',
      'Fees',
      'Card Fee',
      'Gross Income',
      'Outgoings',
      'Net Income',
      'Per Night',
      'Arrival Date',
      'Departure Date'
    ]
  },
  
  // Utility functions
  formatCurrency: (amount) => {
    return new Intl.NumberFormat(SETTINGS.CURRENCY.locale, {
      style: 'currency',
      currency: SETTINGS.CURRENCY.code,
      minimumFractionDigits: 2
    }).format(amount);
  },
  
  formatDate: (timestamp, format = 'display') => {
    const date = new Date(timestamp * 1000);
    if (format === 'display') {
      return date.toLocaleDateString(SETTINGS.CURRENCY.locale);
    }
    return date.toISOString().split('T')[0];
  },
  
  formatNumber: (number, decimals = 2) => {
    return Number(number).toFixed(decimals);
  }
};

export default SETTINGS;